import NotificationsFilter from "./components/NotificationsFilter"
import NotificationsHeader from "./components/NotificationsHeader"
import NotificationsList from "./components/NotificationsList"
import "./style.scss"

const Notifications = () => {
  return (
    <div className='notifications w-100 h-100 d-flex justify-content-center'>
      <div className='notifications-container w-75 d-flex flex-column pb-4'>
        <NotificationsHeader />

        <div className='notifications-content w-100 d-flex flex-row'>
          <NotificationsList />
          <NotificationsFilter />
        </div>
      </div>
    </div>
  )
}

export default Notifications
